import axios, { AxiosPromise } from 'axios';
import { IUser } from '../../../@types/model/auth/user/user';
import { IUserUpsert } from '../../../@types/model/auth/user/userUpsert';
import { IUserToken } from '../../../@types/model/auth/userToken/userToken';
import { IUserAccessPointBulkUpsert } from '../../../@types/model/auth/user/userAccessPointBulkUpsert';
import { IUserEmailView } from '../../../@types/model/auth/user/userEmailView';

export default class UserHttpService {
    public static get = async (userId : number) : Promise<IUser> => {
        const result = await axios.get(`${API_URL}/v1/Rights/User/Get`, {
            params: {
                userId,
            },
        });
        return result.data;
    }

    public static getList = async (signal ?: AbortSignal) : Promise<Array<IUser>> => {
        const result = await axios.get(`${API_URL}/v1/Rights/User/GetList`, {
            signal,
        });
        return result.data;
    }

    public static getUserEmailViewList = async (signal ?: AbortSignal) : Promise<Array<IUserEmailView>> => {
        const result = await axios.get(`${API_URL}/v1/Rights/User/GetUserEmailViewList`, {
            signal,
        });
        return result.data;
    }

    public static upsert = async (upsertData : Array<IUserUpsert>) : Promise<Array<IUser>> => {
        const result = await axios.post(`${API_URL}/v1/Rights/User/Upsert`, upsertData);
        return result.data;
    }

    public static setEmployeeNumber = (employeeNumber : string) : AxiosPromise<IUserToken> => {
        return axios.post(`${API_URL}/v1/Rights/User/SetEmployeeNumber`, null, {
            params: {
                employeeNumber,
            },
        });
    }

    public static linkGoogleAccount = async (code : string) : Promise<IUser> => {
        const result = await axios.post(`${API_URL}/v1/Rights/User/LinkGoogleAccountToUser`, {
            code,
        });

        return result.data;
    }

    public static unlinkGoogleAccount = async () : Promise<IUser> => {
        const result = await axios.post(`${API_URL}/v1/Rights/User/UnlinkGoogleAccountFromUser`);

        return result.data;
    }

    public static updateEmployeeCredentials = async () : Promise<void> => {
        return await axios.post(`${API_URL}/v1/Rights/User/UpdateEmployeeCredentials`);
    }

    public static resetEmployeeCredentials = async () : Promise<void> => {
        return await axios.post(`${API_URL}/v1/Rights/User/ResetEmployeeCredentials`);
    }

    public static requestForgottenPasswordEmail(email : string) : AxiosPromise<void> {
        return axios.post(`${API_URL}/v1/Rights/User/RequestPasswordReset`, null, {
            params: {
                email,
            },
        });
    }

    public static resetPassword(oldPassword : string, newPassword : string, recoveryCode : string) : AxiosPromise<boolean> {
        return axios.post(`${API_URL}/v1/Rights/User/ResetUserPassword`, null, {
            params: {
                oldPassword,
                newPassword,
                recoveryCode,
            },
        });
    }

    public static delete = async (id : number) : Promise<IUser> => {
        const result = await axios.delete(`${API_URL}/v1/Rights/User/Delete`, {
            params: { id },
        });

        return result.data;
    }

    public static updateUserAccessPoints = async (upsert : IUserAccessPointBulkUpsert) : Promise<Array<IUser>> => {
        const result = await axios.post(`${API_URL}/v1/Rights/User/UpdateAccessPoints`, upsert);
        return result.data;
    }
}
